import { render } from "./PromReport.vue?vue&type=template&id=af5e0674&scoped=true"
import script from "./PromReport.vue?vue&type=script&lang=js"
export * from "./PromReport.vue?vue&type=script&lang=js"

import "./PromReport.vue?vue&type=style&index=0&id=af5e0674&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5e0674"]])

export default __exports__